import {
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	HostBinding,
	OnDestroy,
	OnInit,
	ViewChild,
	ViewEncapsulation,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ExperimentConfigService } from "@obg/core.experiment";
import { CoreState } from "@obg/ngx.core";
import { RouteSelector } from "@obg/ngx.router";
import { ScrollToTopService } from "@obg/ngx.ui.global.scrollbar";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

@Component({
	selector: "obg-m-iframe-layout-container",
	templateUrl: "./iframe-layout.container.html",
	styleUrls: ["./iframe-layout.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class IframeLayoutContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-iframe-layout") hostCssClass = true;
	@ViewChild("content", { static: true }) content: ElementRef | undefined;

	title$: Observable<string> | undefined;

	isMfeSbEnabled = false;

	constructor(
		private store: Store<CoreState>,
		private scrollToTopService: ScrollToTopService,
		private experimentConfig: ExperimentConfigService
	) {}

	ngOnInit() {
		this.scrollToTopService.register({
			id: "iframe-layout",
			commandTrigger: true,
			element: {
				scrollTo: () => this.content?.nativeElement.scrollTo(0, 0),
			} as any,
		});
		this.title$ = this.store.select<{ title: string } | undefined>(RouteSelector.getData).pipe(
			filter((data) => !!data?.title),
			map((t) => t!.title)
		);

		this.isMfeSbEnabled = this.experimentConfig.isSBB2BMfeEnabled();
	}

	ngOnDestroy() {
		this.scrollToTopService.unregister("iframe-layout");
	}
}
